import type { PhotoRecord } from "@/lib/catalog/types"
import { selectPhoto } from "@/store/photo/photos-selection-state"

type ModifierEvent = Pick<MouseEvent, "shiftKey" | "ctrlKey" | "metaKey">

export const getSelectionModifiersFromEvent = (
	event: ModifierEvent,
	platform: string = navigator.platform,
) => {
	return {
		isShiftPressed: event.shiftKey,
		isModPressed: event.ctrlKey || (event.metaKey && platform !== "Win32"),
	}
}

export const selectThumbnailPhotoFromClick = (options: {
	photo: PhotoRecord
	event: ModifierEvent
	isStackedPhoto: boolean
	platform?: string
}) => {
	const { photo, event, isStackedPhoto, platform } = options
	const modifiers = getSelectionModifiersFromEvent(event, platform)

	selectPhoto(photo, {
		...modifiers,
		isStackedPhoto,
		fromClick: true,
	})

	return modifiers
}
